import React from 'react'
import { Utils } from '../utils/Utils'

function AgeStats(teams) {


  const getAgeStats = () => {
    return teams.teams.map(team => ({
      nameText: team.name + '&nbsp; <img class="logo-team-small" src="'+team.url_logo+'" alt="'+team.url_logo+'"></img>',
      name: '<img class="logo-team-small" src="'+team.url_logo+'" alt="'+team.url_logo+'"></img>',
      value: getAverageAge(team.players)
    })).sort((a, b) => b.value - a.value);
  }

  const getAverageAge = (players) => {
    if (players === undefined || players.length === 0) return 0
    const totalAge = players.reduce((sum, player) => {
      return sum + Utils.getDecimalAge(player.birthDate)
    }, 0)
    const averageAge = totalAge / players.length
    return averageAge.toFixed(2)
  }

  return (
    <div>
        <table className="table-stats">
          <thead>
            <tr>
              <th>Equipo</th>
              <th>Edad media</th>
            </tr>
          </thead>
          <tbody>
          {getAgeStats().map((item, index) => (
            <tr key={index}>
              <td><div className="label-team" dangerouslySetInnerHTML={{ __html: item.nameText }}></div></td><td className="td-value"> {item.value} años</td>
            </tr>
          ))}
          </tbody>
        </table>
    </div>
  )
}

export default AgeStats